import {
  OffersGrouped as SharedOffersGrouped,
  OffersGroupedContentContractForPageTemplate,
  type OffersGroupedProps,
} from '@cx-web/components/page-template/OffersGrouped';
import { captureException } from '@sentry/react-router';

// NGF-6505: the OffersGrouped wrapper + content contract now live in @cx-web/components (single source
// of truth, shared with atlas-astro). This thin RR7 glue carries the one host-specific concern the
// shared component can't: `onError`, the Sentry capture (@cx-web/components must not depend on
// @sentry/react-router). Placed AFTER the `{...props}` spread so it always wins.
//
// Unlike OFFERS_PAGE, the clickout contract is passed through with the full `${CLICKOUT_URL}/offer/
// clickout` value (no bare-URL override) — offers-grouped consumes clickoutServiceUrl as-is. The
// componentMap entry spreads getOffersClickoutServiceProps unchanged; nothing to override here.
export const OffersGrouped = (props: OffersGroupedProps) => (
  <SharedOffersGrouped {...props} onError={captureException} />
);

export { OffersGroupedContentContractForPageTemplate };
export type { OffersGroupedProps };
